import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const initialState = {
	mode: "light",
	strokeWidth: 3,
	strokeColor: "rgb(204, 0, 8)",
};

export const useSettingStore = create(
	devtools(
		persist(
			(set, get) => ({
				...initialState,
				doMode: (mode) => set({ mode }),
				changeStrokeWidth: (strokeWidth) => set({ strokeWidth }),
				changeStrokeColor: (strokeColor) => set({ strokeColor }),
				resetSettings: () => set(initialState),
			}),
			{
				name: "setting-storage",
			}
		)
	)
);
